<script>
    import { createEventDispatcher } from 'svelte'
    import { fly } from 'svelte/transition'

    import Modal from '../../components/Modal/Modal.svelte'
    import ModalOverlay from '../../components/Modal/ModalOverlay.svelte'
    import SmartField from '../../components/SmartField/SmartField.svelte'
    import userStore from '../../stores/user'


    let ctrlsDisabled   = false,
        firstField      = null,
        name            = ''


    const dispatch = createEventDispatcher ();
    
    const onSave = () => {
        if (validForm) {
            ctrlsDisabled = true;
            dispatch ('save', { name })
        }
    }

    const onCancel = () => {
        dispatch ('cancel')
    }

    $: validForm = name.trim() !== ''
    $: if (firstField) {
        firstField.focus ();
    }
</script>

<ModalOverlay />
<Modal classes="CreateClient" hideOverlay>
    <div class="Editor basic-panel-content">
        <div class="heading">Nuovo Cliente</div>
        <div class="form">
            <SmartField type="input" name="name" label="Nome" bind:value={name} bind:field={firstField} />
        </div>
    </div>
    <div class="ctrls" in:fly={{ y: -60, duration: 300, delay: 300 }}>
        <button class="btn btn-sm btn-primary" disabled={ctrlsDisabled || validForm === false} on:click={onSave}>Crea Cliente</button>
        <button class="btn btn-sm btn-danger" disabled={ctrlsDisabled} on:click={onCancel}>Annulla</button>
    </div>
</Modal>



<style>
    :global(.ProgramEditor) .basic-panel-content {
        width: 400px;
        padding: 0;
        position: relative;
        z-index: 2;
        
    }
    .heading {
        margin-bottom: 10px;
    }
    .ctrls {
        margin-top: 10px;
        text-align: left;
        position: relative;
        z-index: 1;
    }
    .ctrls :global(button) {
        padding: .40rem 1.3rem;
    }
    .ctrls :global(.btn) {
        margin-right: 5px;
    }

    @media(max-width: 800px) {
        :global(.ProgramEditor) {
            width: 100%;
            height: 100%;
        }
        :global(.ProgramEditor) .basic-panel-content {
            width: calc(100% - 50px);
            left: 50px;
        }
    }
</style>